/**
 * Normaliza um número de telefone para uso no WhatsApp (wa.me), garantindo o
 * DDI do Brasil (55) na frente.
 *
 * Regras:
 *  - Remove tudo que não for dígito.
 *  - Se já vier com o DDI 55 (55 + DDD + número = 12 ou 13 dígitos), mantém.
 *  - Caso contrário (número local: DDD + número = 10 ou 11 dígitos), adiciona o 55.
 *
 * Exemplos:
 *  '(11) 99999-9999'   -> '5511999999999'
 *  '11999999999'       -> '5511999999999'
 *  '5511999999999'     -> '5511999999999'
 *  ''                  -> ''
 */
export function normalizeWhatsappNumber(raw?: string | null): string {
  const digits = (raw ?? '').replace(/\D/g, '')
  if (!digits) return ''

  // Já possui o DDI do Brasil (55 + DDD + número).
  if (digits.startsWith('55') && (digits.length === 12 || digits.length === 13)) {
    return digits
  }

  // Número local (DDD + número): adiciona o 55.
  return `55${digits}`
}

/**
 * Monta a URL do WhatsApp (wa.me) já com o número normalizado e, opcionalmente,
 * uma mensagem pré-preenchida.
 */
export function buildWhatsappUrl(raw?: string | null, text?: string): string {
  const number = normalizeWhatsappNumber(raw)
  const base = `https://wa.me/${number}`
  return text ? `${base}?text=${encodeURIComponent(text)}` : base
}
